module.exports = __webpack_public_path__ + "img/fr2.e50d90dc.png";